@file:OptIn(InternalResourceApi::class)

package com.xtream.composeapp.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/com.xtream.composeapp.resources/"

@delegate:ResourceContentHash(1_475_371_105)
public val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_175_469_424)
public val Res.drawable.logo_24: DrawableResource by lazy {
      DrawableResource("drawable:logo_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_861_408_549)
public val Res.drawable.logo_end: DrawableResource by lazy {
      DrawableResource("drawable:logo_end", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_end.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_091_891_812)
public val Res.drawable.logo_light: DrawableResource by lazy {
      DrawableResource("drawable:logo_light", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_light.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-269_280_823)
public val Res.drawable.logo_start: DrawableResource by lazy {
      DrawableResource("drawable:logo_start", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_start.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("logo", Res.drawable.logo)
  map.put("logo_24", Res.drawable.logo_24)
  map.put("logo_end", Res.drawable.logo_end)
  map.put("logo_light", Res.drawable.logo_light)
  map.put("logo_start", Res.drawable.logo_start)
}
